import logger from '../utils/logger';
import { React, useContext, useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../utils/auth";
import { signInWithEmailAndPassword } from "firebase/auth";
import { GlobalStateContext } from '../utils/GlobalStateContext';
import { AuthContext } from '../utils/AuthenticationCheck';
import { Mail, Lock, LogIn } from 'lucide-react';
import '../style/Login.css';
import health_guardian from '../img/health_guardian.webp';

export default function Login() {
    const navigate = useNavigate();

    const { currentUser, setCurrentUser } = useContext(GlobalStateContext);
    const { user, loading } = useContext(AuthContext);
    const BASE_URL = process.env.REACT_APP_API_URL;
    const [loginSuccess, setLoginSuccess] = useState(false); // Track login attempt
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value, // Dynamically update form values based on `name` attribute
        });
    };
    
    useEffect(() => {
        // Reset global state on mount (optional, based on your app's needs)
        setCurrentUser(null);
    }, [setCurrentUser]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // logger.log("Loaded BASE_URL:", process.env.REACT_APP_API_URL);
      const userCredential = await signInWithEmailAndPassword(auth, formData.email, formData.password);
      const userData = userCredential.user;
      setCurrentUser(userData); // Temporary set, will be overridden later
      setLoginSuccess(true); // Indicate login attempt succeeded
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      // logger.log(`Error ${errorCode}: ${errorMessage}`);
      if (errorCode === "auth/invalid-credential") {
        alert("Invalid credentials");
      }
    }
  };
    // const handleSubmit = async (e) => {
    //     e.preventDefault(); // Prevent the default form submission behavior
    //     if (!formData.userType) {
    //         alert("Please select a user type");
    //         return;
    //     }
    //     signInWithEmailAndPassword(auth, formData.email, formData.password)
    //     .then( async (userCredential) => {
    //         const userData = userCredential.user;
    //         try {
    //             const postBody = JSON.stringify({
    //               uId: userData.uid,
    //               email: userData.email,
    //               token: userData.accessToken,
    //             });
    //             logger.log('API URL:', process.env.REACT_APP_API_URL);

    //             const response = await fetch(`${BASE_URL}/RIS/login`, {
    //                 method: 'POST',
    //                 headers: {
    //                     'Content-Type': 'application/json'
    //                 },
    //                 body: postBody
    //             });
    //             setCurrentUser(null);
    //             if (response.ok) {
    //                 logger.log("Login successful");
    //                 setLoginSuccess(true); // Indicate login attempt succeeded
    //                 const responseData = await response.json(); // Parse the response body as JSON
    //                 logger.log(responseData)
    //             }
        
    //                 if (responseData.data.clinicians_id !== null) {
    //                     const { clinicians_id, session_expiration, first_name, last_name } = responseData.data[0];
                       
    //                     setCurrentUser({ clinicians_id, session_expiration, first_name, last_name });
    //                     if (formData.userType === "clinician") {
    //                         navigate("/home");
    //                     }
    //                     if (formData.userType === "radiology") {
    //                         navigate("/radiology");
    //                     }
    //                     if (formData.userType === "lab") {
    //                         navigate("/labs");
    //                     }
    //                     if (formData.userType === "office_staff") {
    //                         navigate("/checkIn");
    //                     }
    //                     if (formData.userType === "admin") {
    //                         navigate("/checkIn");
    //                     }
    //                 }
    //                 else {
    //                     logger.log("Login successful but session not logged");
    //                 }
    //             }
    //             else {
    //                 logger.log("Login failed");
    //             }
    //         }
    //         catch (error) {
    //             logger.log(error)
    //         }
    //     })
    //     .catch((error) => {
    //         const errorCode = error.code;
    //         const errorMessage = error.message;
    //         logger.log(`Error ${errorCode}: ${errorMessage}`)
    //         if (errorCode == "auth/invalid-credential") {
    //             alert("Invalid credentials");
    //         }
    //     });
    // }
    
    useEffect(() => {
      if (loginSuccess && user) { // Wait for both login success and user to be set
          // logger.log('if statement true')
          const performLogin = async () => {
          try {
            const postBody = JSON.stringify({
              uId: user.uid,
              email: user.email,
              token: user.accessToken 
            });
            // logger.log(`Fetching data from: ${BASE_URL}`)
            const response = await fetch(`${BASE_URL}/RIS/login`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              credentials: 'include',
              body: postBody,
            });
            // const contentType = response.headers.get('content-type');
            // const rawText = await response.text();
            // logger.log("Response status:", response.status);
            // logger.log("Content-Type:", contentType);
            // logger.log("Raw response body:", rawText);
            // logger.log("Raw response preview:", rawText.slice(0, 100));
            
            // if (response.ok) {
            //   const responseData = await response.json();
            //   const roleData = responseData.data[0];
            //   const { first_name, last_name, type, session_expiration } = responseData;

            //   let roleKey = null;
            //   let route = null;

            //   switch (true) {
            //   //   case typeof roleData.patients_id === "number":
            //   //     roleKey = { patients_id: roleData.patients_id };
            //   //     route = "/patient";
            //   //     break;
            //     case typeof roleData.rad_tech_id === "number":
            //       roleKey = { rad_tech_id: roleData.rad_tech_id };
            //       route = "/radiology";
            //       break;
            //     case typeof roleData.lab_tech_id === "number":
            //       roleKey = { lab_tech_id: roleData.lab_tech_id };
            //       route = "/labs";
            //       break;
            //     case typeof roleData.office_assistants_id === "number":
            //       roleKey = { office_assistants_id: roleData.office_assistants_id };
            //       route = "/checkIn";
            //       break;
            //     case typeof roleData.clinicians_id === "number":
            //       roleKey = { clinicians_id: roleData.clinicians_id };
            //       route = "/home";
            //       break;
            //     case typeof roleData.biller_id === "number":
            //       roleKey = { biller_id: roleData.biller_id };
            //       route = "/billing";
            //       break;
            //     case typeof roleData.admin_id === "number":
            //       roleKey = { admin_id: roleData.admin_id };
            //       route = "/home";
            //       break;
            //     default:
            //       logger.log("Login failed: Unknown role type");
            //       return;
            //   }

            //   setCurrentUser({
            //     ...roleKey,
            //     session_expiration,
            //     first_name,
            //     last_name,
            //     type,
            //   });

            //   logger.log("Matched role:", roleKey);
            //   logger.log("Routing to:", route);
            //   navigate(route);
            // } else {
            //   logger.log("Login failed");
            // }
        // logger.log("Loaded BASE_URL:", process.env.REACT_APP_API_URL);
        const contentType = response.headers.get('content-type');
        const rawText = await response.text();

        // logger.log("Response status:", response.status);
        // logger.log("Content-Type:", contentType);
        // logger.log("Raw response body:", rawText);
        // logger.log("Raw response preview:", rawText.slice(0, 100));

        if (response.ok && contentType?.includes('application/json')) {
          let responseData;
          try {
            responseData = JSON.parse(rawText);
          } catch (parseError) {
            logger.error("Failed to parse JSON:", parseError);
            return;
          }

          if (responseData.mfaRequired) {
            sessionStorage.setItem('mfaPending', JSON.stringify({
              pendingToken: responseData.pendingToken,
              type: responseData.type,
              first_name: responseData.first_name,
              last_name: responseData.last_name,
            }));
            navigate('/mfa-verify');
            return;
          }

          if (responseData.mfaSetupRequired) {
            // Session was created but MFA enrollment is required before proceeding
            const roleData = responseData.data[0];
            const { first_name, last_name, type } = responseData;
            let roleKey = null;
            switch (true) {
              case typeof roleData.rad_tech_id === 'number':          roleKey = { rad_tech_id: roleData.rad_tech_id }; break;
              case typeof roleData.lab_tech_id === 'number':          roleKey = { lab_tech_id: roleData.lab_tech_id }; break;
              case typeof roleData.office_assistants_id === 'number': roleKey = { office_assistants_id: roleData.office_assistants_id }; break;
              case typeof roleData.clinicians_id === 'number':        roleKey = { clinicians_id: roleData.clinicians_id }; break;
              case typeof roleData.medical_assistants_id === 'number':roleKey = { medical_assistant_id: roleData.medical_assistants_id }; break;
              case typeof roleData.biller_id === 'number':            roleKey = { biller_id: roleData.biller_id }; break;
              case typeof roleData.admin_id === 'number':             roleKey = { admin_id: roleData.admin_id }; break;
              default: return;
            }
            if (roleData.session_token) sessionStorage.setItem('sessionToken', roleData.session_token);
            setCurrentUser({ ...roleKey, first_name, last_name, type, mfa_enabled: false, mfa_enforced: true });
            navigate('/mfa-enforce-setup');
            return;
          }

          const roleData = responseData.data[0];
          // logger.log("Resolved roleData:", roleData);
          const { first_name, last_name, type, session_expiration } = responseData;

          let roleKey = null;
          let route = null;

          switch (true) {
            case typeof roleData.rad_tech_id === "number":
              roleKey = { rad_tech_id: roleData.rad_tech_id };
              route = "/radiology";
              break;
            case typeof roleData.lab_tech_id === "number":
              roleKey = { lab_tech_id: roleData.lab_tech_id };
              route = "/labs";
              break;
            case typeof roleData.office_assistants_id === "number":
              roleKey = { office_assistants_id: roleData.office_assistants_id };
              route = "/checkIn";
              break;
            case typeof roleData.clinicians_id === "number":
              roleKey = { clinicians_id: roleData.clinicians_id };
              route = "/home";
              break;
            case typeof roleData.medical_assistants_id === "number":
              roleKey = { medical_assistant_id: roleData.medical_assistants_id };
              route = "/home";
              break;
            case typeof roleData.biller_id === "number":
              roleKey = { biller_id: roleData.biller_id };
              route = "/billing";
              break;
            case typeof roleData.admin_id === "number":
              roleKey = { admin_id: roleData.admin_id };
              route = "/home";
              break;
            default:
              // logger.log("Login failed: Unknown role type");
              return;
          }

          if (roleData.session_token) sessionStorage.setItem('sessionToken', roleData.session_token);

          setCurrentUser({
            ...roleKey,
            session_expiration,
            first_name,
            last_name,
            type,
            mfa_enabled: responseData.mfa_enabled ?? false,
            mfa_enforced: responseData.mfa_enforced ?? false,
          });

          // logger.log("Matched role:", roleKey);
          // logger.log("Routing to:", route);
          navigate(route);
        } else {
          // Do not log the user's email (PII) to the console.
          logger.error(`Login failed. Status: ${response.status}`);
        }
        } catch (error) {
          // logger.log("API error:", error);
        }
      };

      performLogin();
    }
  }, [loginSuccess, user, navigate, setCurrentUser]);


  return (
    <div className="login-page">
      <div className="login-bg-image" />
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo-wrap">
            <img src={health_guardian} alt="Health Guardian Imaging Logo" className="login-logo" />
          </div>
          <h1 className="login-title">Radiology Information System</h1>
          <p className="login-subtitle">Health Hub Clinic & Health Guardian Imaging</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-input-group">
            <Mail className="login-input-icon" size={18} />
            <input
              type="email"
              name="email"
              placeholder="Email address"
              value={formData.email}
              onChange={handleChange}
              className="login-input"
            />
          </div>

          <div className="login-input-group">
            <Lock className="login-input-icon" size={18} />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              className="login-input"
            />
          </div>

          <button type="submit" className="login-submit-btn">
            <LogIn size={18} />
            <span>Sign In</span>
          </button>
        </form>

        <div className="login-footer">
          <span>Powered by Health Direct Plus</span>
        </div>
      </div>
    </div>
  );
};